import dayjs from "../utils/dayjs"
import { store } from "../app/store"
import { setValueLists } from "../app/slices/valueListSlice"
import { FindValueListRq } from "@smartx/mikro-vt-client-api"
import { RequestHeader } from "../utils/utils"
import { valueListApi } from "../api/apiClient"

export enum VALUE_LIST_ENUM {
  BranchRegionList = "MIKRO_BRANCH_REGION_LIST",
  CountryList = "MIKRO_COUNTRY_LIST",
  CrRatingList = "MIKRO_CR_RATING_LIST",
  CustomDecisionList = "MIKRO_CUSTOM_DECISION_LIST",
  DecisionLevelList = "MIKRO_DECISION_LEVEL_LIST",
  IdTypeList = "MIKRO_ID_TYPE_LIST",
  InterestBaseListEh = "MIKRO_INTEREST_BASE_LIST_EH",
  InterestBaseListFh = "MIKRO_INTEREST_BASE_LIST_FH",
  ProductList = "MIKRO_PRODUCT_LIST",
  ActiveStateList = "MIKRO_ACTIVE_STATE_LIST",
  DocumentDescriptionList = "MIKRO_DOCUMENT_DESCRIPTION_LIST",
  DocumentTypeList = "MIKRO_DOCUMENT_TYPE_LIST",
  LoanPurposeListEh = "MIKRO_LOAN_PURPOSE_LIST_EH",
  LoanPurposeListFh = "MIKRO_LOAN_PURPOSE_LIST_FH",
  RectificationReasonsList = "MIKRO_RECTIFICATION_REASONS_LIST",
  RefinancedLoanTypesEh = "MIKRO_REFINANCED_LOAN_TYPES_EH",
  RefinancedLoanTypesFh = "MIKRO_REFINANCED_LOAN_TYPES_FH",
  StateListSearch = "MIKRO_STATE_LIST_SEARCH",
  StateList = "MIKRO_STATE_LIST",
  OnlineStateList = "MIKRO_ONLINE_STATE_LIST",
  SuspensionReasonsList = "MIKRO_SUSPENSION_REASONS_LIST",
  OperationFormList = "MIKRO_OPERATION_FORM_LIST",
  RepaymentFrequencyList = "MIKRO_REPAYMENT_FREQUENCY_LIST",
  RepresentationModeList = "MIKRO_REPRESENTATION_MODE_LIST",
  TeaorCodeList = "MIKRO_TEAOR_CODE_LIST",
  CaseEventTypeList = "MIKRO_CASE_EVENT_TYPE_LIST",
  PrescreenStateList = "MIKRO_PRESCREEN_STATE_LIST",
  YesNoCode = "MIKRO_YES_NO_CODE",
  SuppliersNumber = "MIKRO_SUPPLIERS_NUMBER",
  SupplierDistribution = "MIKRO_SUPPLIER_DISTRIBUTION",
  MarketSize = "MIKRO_MARKET_SIZE",
  GuaranteerList = "MIKRO_GUARANTEER_LIST",
  SapStreetType = "MIKRO_SAP_STREET_TYPE",
  SapFloor = "MIKRO_SAP_FLOOR",
  BiancoCurrency = "MIKRO_BIANCO_CURRENCY",
  LoanPurposeListBiancoAltalanos = "MIKRO_LOAN_PURPOSE_LIST_BIANCO_ALTALANOS",
  LoanPurposeListBiancoJelzalog = "MIKRO_LOAN_PURPOSE_LIST_BIANCO_JELZALOG",
  LoanPurposeListBiancoLombardEh = "MIKRO_LOAN_PURPOSE_LIST_BIANCO_LOMBARD_EH",
  LoanPurposeListBiancoLombardFh = "MIKRO_LOAN_PURPOSE_LIST_BIANCO_LOMBARD_FH",
  BankGuaranteeType = "MIKRO_BANK_GUARANTEE_TYPE",
  InterestBaseListParam = "MIKRO_INTEREST_BASE_LIST_PARAM",
  InterestBaseListBiancoParam = "MIKRO_INTEREST_BASE_LIST_BIANCO_PARAM",
}

export async function setCodeTableValues() {
  const tables: string[] = Object.values(VALUE_LIST_ENUM)

  const rq: FindValueListRq = {
    header: new RequestHeader(),
    valueListCodes: tables,
    language: "HU",
    selector: "",
    date: dayjs().format(),
  }

  const res = await valueListApi.findValueList(rq)

  const localValueLists = {
    saveDate: dayjs().format(),
    valueLists: res.data.valueLists,
  }

  store.dispatch(setValueLists(localValueLists))
  localStorage.setItem("VTM-VALUELISTS", JSON.stringify(localValueLists))
}
